import React, { useRef, useEffect } from 'react'
import Experience from './Experience.jsx'
import { gsap } from 'gsap'
import useVantas from '../../use_vantas.js'

import EXPERIENCE_ACEPTACION_IMAGE_PATH from 'images/experience_aceptacion.jpg'
import EXPERIENCE_ACEPTACION_SONG_PATH from 'audio/3. CICLOS MB.mp3'

const AceptacionText = () => (
	<span className="text-left">
		<p>El dolor, compañero. Cambiar el efecto de su paso por tu vida con la  trasmutación.</p>

		<p>Abrazalo y crea desde él.</p>
		<p>Aceptalo y nada más.</p>
		<p>Comprender hasta cuánto es co-creador de tu presente.</p>
		<p>Reconocí mis dolores y los materialice en mi cuerpo para calmar la angustia.</p>
		<p>Vi mis sueños ser abatidos, como aves en manos de cazadores deportivos.</p>
		<p>No me refugio en el dolor. Lo nombro.</p>
		<p>Me doy el amor, las caricias que faltaron y la aceptación de mi necesidad profunda de contención.</p>
		<p>Esa es mi falta. ¿Cuál es la tuya?</p>
		<p>Ahí está el camino.</p>
		<p>Convertite en quién te sane las heridas.</p>
	</span>
)


import FOG from 'vanta/src/vanta.fog.js'

const ExperienceAceptacion = ({ is_active , ...props }) => {
	const [ canvas_root_ref, , canvasFadeOut ] = useVantas({
		is_active,
		effect: FOG,
		effect_options:{
			baseColor: 0x00,
			highlightColor: 0xffc300,
			midtoneColor: 0xff1f00,
			lowlightColor: 0x2d00ff,
			blurFactor: 0.29,
			speed: 0.30,
			zoom: 0.20
		},
		canvasFadeIn: canvas => {
			gsap.fromTo(canvas, { opacity: 0 }, { opacity: 0.55, duration: 2 })
		}
	});

	return (<Experience
		r_ref={canvas_root_ref}
		image={EXPERIENCE_ACEPTACION_IMAGE_PATH}
		title={"Aceptacion"}
		phrase={"¿Podés nombrar tu dolor sin habitarlo por siempre, y desde ahí, ofrecerte el amor que faltó, como quien riega una flor que aún no sabe que puede crecer?"}
		phrase_rect={{ top: 40, left: 26, width: 47, height: 20 }}
		text={<AceptacionText />}
		text_rect={{ top: 45, left: 72, width: 40, height: 70 }}
		text_interaction_zone_rect={{ top: 55, left: 13.7, width: 7, height: 10 }}
		song={EXPERIENCE_ACEPTACION_SONG_PATH}
		song_rect={{ top: 75, left: 43, width: 7, height: 10 }}
		onBeforeBack={canvasFadeOut}
		is_active={is_active}
		{...props}
	/>)
}

export default ExperienceAceptacion